export class StickyHeader {
	constructor(args) {
		const self = this;

		// Default args
		const defaults = {
			offsetTop: 40
		};

		// Default args
		this.options = Object.assign({}, defaults, args);

		// Get header element
		this.header_el = document.querySelector('.site-header');

		// Keep sticky state
		this.is_sticky = false;

		// On scroll, fire event to "onScroll" method
		window.addEventListener('scroll', debounce(function () {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			self.onScroll(scrollTop);
		}, 10, true));
	}

	onScroll(scrollTop) {
		// Make sure the header is at the top of the viewport
		let header_bounding_rect = this.header_el.getBoundingClientRect();
		let header_is_at_top = header_bounding_rect.top <= 0;


		// If we've passed the threshold and we're not sticky, make it sticky
		if (scrollTop >= this.options.offsetTop && !this.is_sticky && header_is_at_top) {
			// this.header_el.classList.add('sticky');
			this.is_sticky = true;
		} else if ((scrollTop < this.options.offsetTop || !header_is_at_top) && this.is_sticky) {
			// Otherwise, if we're below the threshold, but we're sticky, make it not sticky
			// this.header_el.classList.remove('sticky');
			this.is_sticky = false;
		}
	}
}

function debounce(func, wait, immediate) {
	var timeout;
	return () => {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

// Initialize sticky header
new StickyHeader({
	offsetTop: 60
});
